module.exports = __webpack_public_path__ + "img/edc-cc-bca.7023babb.png";